// extracted by mini-css-extract-plugin
export default {"agentContainer":"Releases_agentContainer__p5-1D","oldVersionsGrid":"Releases_oldVersionsGrid__QBpdZ","oldVersionsGridLinux":"Releases_oldVersionsGridLinux__V-TuL"};